import React from 'react';
import './StudentsPage.css';

const StudentsPage = () => {
  return (
    <div className="students-page">
      {/* Hero Section */}
      <section className="students-hero">
        <div className="container">
          <div className="students-hero-grid">
            <div className="students-hero-content">
              <h1 className="students-hero-title">
                Clarity for Every Career Path After Class 12
              </h1>
              <p className="students-hero-subtitle">
                Explore careers, entrance exams, colleges, fees, and admission pathways across all streams — all in one place.
              </p>
              <div className="students-hero-cta">
                <button className="btn btn-primary">Explore Career Options</button>
                <button className="btn btn-secondary">Check College Pathways</button>
              </div>
            </div>
            <div className="students-hero-illustration">
              <img
                src="/students_banner.png"
                alt="Group of students with career pathway icons"
                className="students-illustration-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* The Student Problem Section */}
      <section className="section student-problem-section">
        <div className="container">
          <h2 className="section-title">The Student Problem</h2>

          <div className="student-problem-grid">
            <div className="student-problem-cards">
              <div className="student-problem-card">
                <div className="problem-icon yellow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                  </svg>
                </div>
                <div>
                  <h3>Too many career choices</h3>
                  <p>Information are orsimergats that about information man the information</p>
                </div>
              </div>

              <div className="student-problem-card">
                <div className="problem-icon blue">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="12" y1="18" x2="12" y2="12" />
                    <line x1="9" y1="15" x2="15" y2="15" />
                  </svg>
                </div>
                <div>
                  <h3>Confusing entrance exams</h3>
                  <p>Analyze in symentur sourses other guidance reactives seats</p>
                </div>
              </div>

              <div className="student-problem-card">
                <div className="problem-icon orange">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                </div>
                <div>
                  <h3>Misinformation from multiple websites</h3>
                  <p>Sources sources of aregnass facts, unverified sources ems</p>
                </div>
              </div>
            </div>

            <div className="dashboard-mockup-container">
              <div className="dashboard-mockup-student">
                <div className="mockup-browser-bar">
                  <div className="browser-dots">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                  </div>
                  <span className="browser-url">12thplus.com</span>
                  <span className="browser-label">Dashboard</span>
                </div>
                <div className="mockup-content">
                  <div className="mockup-sidebar-student">
                    <div className="sidebar-icon active"></div>
                    <div className="sidebar-icon"></div>
                    <div className="sidebar-icon"></div>
                  </div>
                  <div className="mockup-main-student">
                    <div className="mini-cards">
                      <div className="mini-card orange"></div>
                      <div className="mini-card blue"></div>
                      <div className="mini-card green"></div>
                    </div>
                    <div className="mini-chart"></div>
                  </div>
                </div>
                <div className="powered-by-badge">
                  <span>Pwed paasd by 12thplus</span>
                  <span className="brand">12th<span className="plus">plus</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How 12thPlus Helps Students */}
      <section className="section helps-section">
        <div className="container">
          <h2 className="section-title">How 12thPlus Helps Students</h2>

          <div className="helps-grid">
            <div className="helps-card">
              <div className="helps-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5" />
                  <path d="M2 12l10 5 10-5" />
                </svg>
              </div>
              <h3>Career exploration across all streams</h3>
            </div>

            <div className="helps-card">
              <div className="helps-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c3 3 9 3 12 0v-5" />
                </svg>
              </div>
              <h3>Entrance exam-based college guidance</h3>
            </div>

            <div className="helps-card">
              <div className="helps-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <path d="M9 15l2 2 4-4" />
                </svg>
              </div>
              <h3>Non-exam pathways for Commerce & Arts</h3>
            </div>

            <div className="helps-card">
              <div className="helps-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
              </div>
              <h3>Fee structures and eligibility slatity</h3>
            </div>

            <div className="helps-card">
              <div className="helps-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9 11l3 3L22 4" />
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
              </div>
              <h3>Step-by-step admission guidance</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Streams Covered */}
      <section className="section streams-covered-section">
        <div className="container">
          <h2 className="section-title">Streams Covered</h2>

          <div className="streams-grid-student">
            {['Engineering', 'Medical', 'Commerce', 'Law', 'Arts', 'Architecture', 'Study Abroad'].map((stream, index) => (
              <div key={index} className="stream-tag">
                <div className="stream-tag-icon">
                  {stream === 'Engineering' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>}
                  {stream === 'Medical' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>}
                  {stream === 'Commerce' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>}
                  {stream === 'Law' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>}
                  {stream === 'Arts' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 19l7-7 3 3-7 7-3-3z" /><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" /><path d="M2 2l7.586 7.586" /><circle cx="11" cy="11" r="2" /></svg>}
                  {stream === 'Architecture' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" /></svg>}
                  {stream === 'Study Abroad' && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>}
                </div>
                <span>{stream}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Entrance Exam Guidance & Non-Entrance Pathways */}
      <section className="section guidance-section">
        <div className="container">
          <div className="guidance-grid">
            <div className="guidance-card">
              <h2>Entrance Exam Guidance</h2>
              <p>We support your exams, cut-offs, and timelines, determine rmnt exam-rate.</p>
              <div className="exam-flow">
                <div className="flow-item">
                  <div className="flow-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                  </div>
                  <span>Exams</span>
                </div>
                <span className="flow-arrow">→</span>
                <div className="flow-item">
                  <div className="flow-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M18 20V10" /><path d="M12 20V4" /><path d="M6 20v-6" />
                    </svg>
                  </div>
                  <span>Cut-offs</span>
                </div>
                <span className="flow-arrow">→</span>
                <div className="flow-item">
                  <div className="flow-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                      <path d="M9 16l2 2 4-4" />
                    </svg>
                  </div>
                  <span>Timeline</span>
                </div>
              </div>
            </div>

            <div className="guidance-card">
              <h2>Non-Entrance Career Pathways</h2>
              <p>Options on for Commerce and Arts pathways with course mapping and other reurises.</p>
              <div className="pathway-links">
                <div className="pathway-link">
                  <span className="pathway-icon">📊</span>
                  <span>Commerce</span>
                  <span className="pathway-arrow">Course mapping →</span>
                </div>
                <div className="pathway-link">
                  <span className="pathway-icon">🎨</span>
                  <span>Arts</span>
                  <span className="pathway-arrow">Course mapping →</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Career Pathways & News */}
      <section className="section career-news-section">
        <div className="container">
          <div className="career-news-grid">
            <div className="career-pathways-card">
              <h2>Career Pathways & Outcomes</h2>
              <p>Long-term careers care anth-wnorition eoperlambs/ careoii long-term careers.</p>
              <div className="career-diagram">
                <svg viewBox="0 0 300 150" className="career-svg">
                  <text x="20" y="20" fontSize="10" fill="#6B7280">Conerbre nectex</text>
                  <path d="M50 80 L100 80" stroke="#F97316" strokeWidth="3" fill="none" />
                  <path d="M100 80 L130 50" stroke="#F97316" strokeWidth="3" fill="none" />
                  <path d="M100 80 L130 80" stroke="#5DADE2" strokeWidth="3" fill="none" />
                  <path d="M100 80 L130 110" stroke="#10B981" strokeWidth="3" fill="none" />
                  <polygon points="128,48 138,50 130,58" fill="#F97316" />
                  <polygon points="128,78 138,80 128,82" fill="#5DADE2" />
                  <polygon points="128,108 138,110 130,118" fill="#10B981" />
                  <text x="30" y="90" fontSize="9" fill="#6B7280">Stoff</text>
                  <text x="140" y="55" fontSize="9" fill="#6B7280">Job</text>
                  <text x="140" y="85" fontSize="9" fill="#6B7280">Careers</text>
                  <text x="140" y="115" fontSize="9" fill="#6B7280">Eed.</text>
                  <text x="180" y="55" fontSize="9" fill="#6B7280">Cuning</text>
                  <text x="180" y="85" fontSize="9" fill="#6B7280">Grerers</text>
                </svg>
              </div>
            </div>

            <div className="news-section">
              <h2>News & Updates</h2>
              <div className="news-cards">
                <div className="news-card">
                  <div className="news-icon">🔔</div>
                  <div>
                    <h4>Exam Notifications</h4>
                    <p>You wrise the sniments at Nov of 2024</p>
                  </div>
                </div>
                <div className="news-card">
                  <div className="news-icon">📅</div>
                  <div>
                    <h4>Deadlines</h4>
                    <p>You mis swimmt ME2T from netification.</p>
                  </div>
                </div>
              </div>

              <div className="trust-reliability">
                <h3>Trust & Reliability</h3>
                <div className="trust-items">
                  <div className="trust-item-student">
                    <span className="trust-check">✓</span>
                    <div>
                      <h4>Verified Information</h4>
                      <p>Learn abeut ar the information</p>
                    </div>
                  </div>
                  <div className="trust-item-student">
                    <span className="trust-check">👥</span>
                    <div>
                      <h4>Student Focus</h4>
                      <p>Students acerses site tonentiewer eats</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section-student">
        <div className="container">
          <div className="cta-buttons">
            <button className="btn btn-primary btn-lg">Start Exploring Your Options</button>
            <button className="btn btn-secondary btn-lg">Plan Your Path After Class 12</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StudentsPage;
